import { ProviderType, ResourceType } from "../../../services/cloudchipr.api";
import { allResourceTypesWithProviders } from "../../constants/resources/allResourceTypesWithProviders";

export const getProviderTypeByResourceType = (
  resourceType: ResourceType,
): ProviderType => {
  return allResourceTypesWithProviders[resourceType];
};
